import { FC } from "react";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { StyledCollectionIcon, StyledNoteIcon } from "./combobox-list-item.style";

type Props = {
  kind: MemCommonMentionKind;
  collectionId?: string;
};

export const MDSComboboxListItemIcon: FC<Props> = ({ kind, collectionId }) => {
  const isCollection = kind === MemCommonMentionKind.Collection;
  const isNote = kind === MemCommonMentionKind.Note;

  if (isCollection) {
    return (
      <StyledCollectionIcon
        aria-label="Collection"
        data-mds-name="combobox-list-item-icon"
        collectionId={collectionId || ""}
      >
        <MdsIcon kind={MdsIconKind.Collection} />
      </StyledCollectionIcon>
    );
  }

  if (isNote) {
    return (
      <StyledNoteIcon aria-label="Note" data-mds-name="combobox-list-item-icon">
        <MdsIcon kind={MdsIconKind.Document} />
      </StyledNoteIcon>
    );
  }

  return null;
};
